module.exports = __webpack_public_path__ + "img/en-rise-smarthome-img-mobile.24d5103a.jpg";